import api from "./client";
export async function listContacts(params) {
    const query = new URLSearchParams();
    if (params?.page)
        query.set("page", String(params.page));
    if (params?.limit)
        query.set("limit", String(params.limit));
    const qs = query.toString();
    const res = await api.get(`/admin/contacts${qs ? `?${qs}` : ""}`);
    return res.data;
}
export async function getContact(id) {
    const res = await api.get(`/admin/contacts/${id}`);
    return res.data;
}
export async function markAsRead(id) {
    const res = await api.patch(`/admin/contacts/${id}/read`);
    return res.data;
}
export async function deleteContact(id) {
    await api.delete(`/admin/contacts/${id}`);
}
